import React ,{Component} from "react";
import {Col, Row} from "react-bootstrap";
import {currencyFormat} from "../helpers";
import toInt from "validator/es/lib/toInt";
import {fileTypes, PortionTypes} from "../constants";

class EstateInfo extends Component {
    render() {
        let file_type = fileTypes[this.props.file.file_type_id] ?? '';
        let portion_type = PortionTypes.find(item => item.id == this.props.file.part_type);
        let portion_type_name = portion_type ? portion_type.name : '-';
        let salablePart = this.props.file.bank_part + ' ' + portion_type_name + ' از ' + this.props.file.total_parts + ' ' + portion_type_name;

        let title = `${file_type} ${this.props.file.usage_type} واقع در استان ${this.props.file.province} شهر ${this.props.file.city} ${this.props.file.address ? this.props.file.address : ''}`;

        let color = '';
        let executive_status = toInt(this.props.file.executive_status);
        if ([5].includes(executive_status)) {
            color = 'color-red';
        } else if ([3].includes(executive_status)) {
            color = 'color-green';
        } else if ([4,6,9].includes(executive_status)) {
            color = 'color-gray';
        } else if ([1].includes(executive_status)) {
            color = 'color-yellow';
        } else if ([2,8].includes(executive_status)) {
            color = 'color-orange';
        } else if ([21,24,36].includes(executive_status)) {
            color = 'color-purple';
        }

        return (
            <div className="product-info">
                <div className="top-info">
                    <div className="d-flex align-items-center">
                        <div>
                            <h5 className="line-height-3">{title}</h5>
                        </div>
                    </div>
                    <div className="text mt-30">
                        <p className={[5,6].includes(executive_status) ? 'color-red' : 'color-green'}>
                            {[5,6].includes(executive_status) ? 'تخلیه به عهده خریدار' : 'قابل تحویل'}
                        </p>
                        <p>
                            {this.props.file.is_negotiation
                                ? 'با توجه به تغییرات در مشخصات املاک، ملاک عمل اطلاعات و قیمت اعلامی توسط کارشناسان فروش شرکت می‌باشد. 42607777-021'
                                : ''}
                        </p>
                        <p className="bottom30">{this.props.descriptions}</p>
                        {this.props.request_url
                                ? <div className="request-button mt-30">
                                    <a href={this.props.request_url} className="butn butn-md butn-bord radius-30" style={{cursor: 'pointer'}}>
                                        <span className="text"> درخواست شرکت در مزایده الکترونیک</span>
                                    </a>
                                </div>
                                : ''
                            }
                    </div>
                </div>
                <div className="prod-order pt-30 pb-30 mt-50 bord-thin-top bord-thin-bottom">
                    <div className="mt-40">
                        <Row>
                            <Col lg={6}>
                                <ul className="rest">
                                    <li className={"d-flex align-items-center mb-15 " + color}>
                                        <strong>کد پرونده : </strong>
                                        <span className="ml-10">{this.props.file.file_code ?? '-'}</span>
                                    </li>
                                    <li className="d-flex align-items-center mb-15">
                                        <strong>قیمت کل : </strong>
                                        <span className="ml-10">
                                        {this.props.file.bank_part_price !== null
                                            ? currencyFormat(this.props.file.bank_part_price)
                                            : '-'}
                                        </span>
                                    </li>
                                    <li className="d-flex align-items-center mb-15">
                                        <strong>میزان سهم قابل فروش : </strong>
                                        <span className="ml-10">{[4,6,9].includes(toInt(this.props.file.executive_status)) ? salablePart : '-'}</span>
                                    </li>
                                    <li className="d-flex align-items-center mb-15">
                                        <strong>مساحت عرصه : </strong>
                                        <span className="ml-10">{this.props.file.land_meter ?? '-'}</span>
                                    </li>
                                    <li className="d-flex align-items-center mb-15">
                                        <strong>مساحت اعیان : </strong>
                                        <span className="ml-10">{this.props.file.total_meters ?? '-'}</span>
                                    </li>
                                    <li className="d-flex align-items-center mb-15">
                                        <strong>سال ساخت : </strong>
                                        <span className="ml-10">{this.props.file.building_age ?? "-"}</span>
                                    </li>
                                </ul>
                            </Col>
                            <Col lg={6}>
                                <ul className="rest">
                                    <li className="d-flex align-items-center mb-15">
                                        <strong>انباری : </strong>
                                        <span className="ml-10">
                                            {this.props.file.is_warehouse == 1 ? "دارد" : "-"}
                                        </span>
                                    </li>
                                    <li className="d-flex align-items-center mb-15">
                                        <strong>آسانسور : </strong>
                                        <span className="ml-10">
                                            {this.props.file.is_elevator == 1 ? "دارد" : "-"}
                                        </span>
                                    </li>
                                    <li className="d-flex align-items-center mb-15">
                                        <strong>تعداد طبقات : </strong>
                                        <span className="ml-10">
                                            {this.props.file.floor_count > 0 ? this.props.file.floor_count : '-'}
                                        </span>
                                    </li>
                                    <li className="d-flex align-items-center mb-15">
                                        <strong>خواب : </strong>
                                        <span className="ml-10">
                                            {this.props.file.bedroom_count > 0 ? this.props.file.bedroom_count : '-'}
                                        </span>
                                    </li>
                                    <li className="d-flex align-items-center mb-15">
                                        <strong>پارکینگ : </strong>
                                        <span className="ml-10">
                                            {this.props.file.parking_count > 0 ? this.props.file.parking_count : '-'}
                                        </span>
                                    </li>
                                </ul>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        );
    }
}

export default EstateInfo;
